<div class="quick-actions-menu">
  <button
    type="button"
    class="quick-actions-menu__back"
    *ngIf="canGoBack"
    (click)="back.emit()"
  >
    <i class="fas fa-chevron-left"></i>
    <span>Ações</span>
  </button>

  <div class="quick-actions-menu__search">
    <i class="fas fa-search quick-actions-menu__search-icon"></i>
    <input
      #searchRef
      type="text"
      class="quick-actions-menu__search-field"
      placeholder="Buscar ação..."
      [value]="searchQuery"
      (input)="onSearch($event)"
      (keydown)="onSearchKeydown($event)"
    />
  </div>

  <div *ngIf="isSearching" class="quick-actions-menu__list" #listRef>
    <button
      *ngFor="let action of filteredActions; let i = index"
      type="button"
      class="quick-actions-menu__item"
      [class.quick-actions-menu__item--active]="i === highlightedIndex"
      (mouseenter)="setHighlight(i)"
      (mouseleave)="setHighlight(-1)"
      (click)="onActionClick(action)"
    >
      <i class="quick-actions-menu__icon" [ngClass]="iconOf(action)"></i>
      <span class="quick-actions-menu__texts">
        <span class="quick-actions-menu__title">{{ action.title }}</span>
        <span *ngIf="action.description" class="quick-actions-menu__desc">{{
          action.description
        }}</span>
      </span>
    </button>
    <span *ngIf="!filteredActions.length" class="quick-actions-menu__empty">
      Nenhuma ação encontrada
    </span>
  </div>

  <div *ngIf="!isSearching" class="quick-actions-menu__list" #listRef>
    <ng-container *ngFor="let domainEntry of domainsWithActions">
      <span class="quick-actions-menu__group-label">{{ domainEntry.domain.name }}</span>
      <button
        *ngFor="let action of domainEntry.actions"
        type="button"
        class="quick-actions-menu__item"
        [class.quick-actions-menu__item--active]="navigableActions.indexOf(action) === highlightedIndex"
        (mouseenter)="setHighlight(navigableActions.indexOf(action))"
        (mouseleave)="setHighlight(-1)"
        (click)="onActionClick(action)"
      >
        <i class="quick-actions-menu__icon" [ngClass]="iconOf(action)"></i>
        <span class="quick-actions-menu__texts">
          <span class="quick-actions-menu__title">{{ action.title }}</span>
          <span *ngIf="action.description" class="quick-actions-menu__desc">{{
            action.description
          }}</span>
        </span>
      </button>
    </ng-container>
  </div>
</div>
